import {Injectable} from '@angular/core';
import {BaseRequestOptions, Http, Response, URLSearchParams} from '@angular/http';
import {Observable} from 'rxjs/Rx';

import {Campagne} from './campagne.model';
import {DateUtils} from 'ng-jhipster';

@Injectable()
export class CampagneService {

    private resourceUrl = 'api/campagnes';
    private resourceFormationsUrl = 'api/campagnes-formations';

    private static copyCampagne(campagne: Campagne): Campagne {
        if (campagne.heureFermeture != null) {
            campagne.dateFermeture = new Date(campagne.dateFermeture.getFullYear(),
                campagne.dateFermeture.getMonth(), campagne.dateFermeture.getDate(),
                campagne.heureFermeture.getHours(), campagne.heureFermeture.getMinutes(),
                campagne.heureFermeture.getSeconds());
        }
        if (campagne.heureOuverture != null) {
            campagne.dateOuverture = new Date(campagne.dateOuverture.getFullYear(),
                campagne.dateOuverture.getMonth(), campagne.dateOuverture.getDate(),
                campagne.heureOuverture.getHours(), campagne.heureOuverture.getMinutes(),
                campagne.heureOuverture.getSeconds());
        }
        return campagne;
    }

    private static createRequestOption(req?: any): BaseRequestOptions {
        let options: BaseRequestOptions = new BaseRequestOptions();
        if (req) {
            let params: URLSearchParams = new URLSearchParams();
            params.set('page', req.page);
            params.set('size', req.size);
            if (req.sort) {
                params.paramsMap.set('sort', req.sort);
            }
            params.set('query', req.query);
            if (req && req.restrictionEmail) {
                params.set('restrictionEmail', req.restrictionEmail);
            }
            options.search = params;
        }
        return options;
    }

    constructor(private http: Http, private dateUtils: DateUtils) { }

    create(campagne: Campagne): Observable<Campagne> {
        let copy: Campagne = Object.assign({}, campagne);
        copy.dateCreation = new Date();
        copy.dateModification = new Date();
        return this.http.post(this.resourceUrl, CampagneService.copyCampagne(copy)).map((res: Response) => {
            return this.convertHeures(res.json());
        });
    }

    update(campagne: Campagne): Observable<Campagne> {
        let copy: Campagne = Object.assign({}, campagne);
        return this.http.put(this.resourceUrl, CampagneService.copyCampagne(copy)).map((res: Response) => {
            return this.convertHeures(res.json());
        });
    }

    updateFormations(campagnes: Campagne[]): Observable<Campagne[]> {
        let copy: Campagne[] = campagnes.splice(0);
        return this.http.put(this.resourceFormationsUrl, copy).map((res: Response) => {
            return res.json();
        });
    }

    delete(id: number): Observable<Response> {
        return this.http.delete(`${this.resourceUrl}/${id}`);
    }

    find(id: number): Observable<Campagne> {
        return this.http.get(`${this.resourceUrl}/${id}`).map((res: Response) => {
            let jsonResponse = res.json();
            jsonResponse.dateCreation = this.dateUtils
                .convertDateTimeFromServer(jsonResponse.dateCreation);
            jsonResponse.dateModification = this.dateUtils
                .convertDateTimeFromServer(jsonResponse.dateModification);
            jsonResponse.dateSuppression = this.dateUtils
                .convertDateTimeFromServer(jsonResponse.dateSuppression);
            return this.convertHeures(jsonResponse);
        });
    }


    query(req?: any): Observable<Response> {
        let options = CampagneService.createRequestOption(req);
        return this.http.get(this.resourceUrl, options)
            .map((res: any) => this.convertResponse(res))
        ;
    }

    campagnesAnneeCourante(): Observable<Response> {
        return this.http.get(this.resourceUrl + '/anneecourante')
            .map((res: any) => this.convertResponse(res))
            ;
    }



    public convertHeures(campagne: Campagne): Campagne {
        campagne.dateOuverture = this.dateUtils
            .convertDateTimeFromServer(campagne.dateOuverture);
        campagne.dateFermeture = this.dateUtils
            .convertDateTimeFromServer(campagne.dateFermeture);
        campagne.heureFermeture = campagne.dateFermeture;
        campagne.heureOuverture = campagne.dateOuverture;
        return campagne;
    }

    private convertResponse(res: any): any {
        let jsonResponse = res.json();
        for (let i = 0; i < jsonResponse.length; i++) {
            jsonResponse[i].dateOuverture = this.dateUtils
                .convertDateTimeFromServer(jsonResponse[i].dateOuverture);
            jsonResponse[i].dateFermeture = this.dateUtils
                .convertDateTimeFromServer(jsonResponse[i].dateFermeture);
            jsonResponse[i].dateCreation = this.dateUtils
                .convertDateTimeFromServer(jsonResponse[i].dateCreation);
            jsonResponse[i].dateModification = this.dateUtils
                .convertDateTimeFromServer(jsonResponse[i].dateModification);
            jsonResponse[i].dateSuppression = this.dateUtils
                .convertDateTimeFromServer(jsonResponse[i].dateSuppression);
        }
        res._body = jsonResponse;
        return res;
    }

}



// WEBPACK FOOTER //
// ./src/main/webapp/app/entities/campagne/campagne.service.ts